import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow",
  "use": "arrow-usage",
  "viewBox": "0 0 18.4 14.8",
  "content": "<symbol viewBox=\"0 0 18.4 14.8\" id=\"arrow\">\n<rect y=\"6.4\" width=\"17\" height=\"2\" />\n<polygon points=\"12,14.8 10.4,13.5 15.6,7.4 10.4,1.3 12,0 18.4,7.4 \" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/components/controls/sprite/arrow.svg
// module id = UYpx
// module chunks = 0